import { query, mutation } from '@/dex-shared/helpers/graphql';

const weeklyAssessmentIdentifier = '[MATEMATICA|NATUREZA|HUMANAS|LINGUAGENS]';

export default {
  state: {
    exams: [],
    exam: null,
    questions: [],
    fileBoxes: [],
    examGroups: [],
  },
  getters: {
    currentExam: (state: any) => {
      if (state.exam) {
        let assignment = false;
        let questionNodes = state.exam.examQuestionsByExamId;
        let questions;
        let fileBoxes;
        let examGroups;
        let isUeeWeeklyAssessment;
        if (questionNodes) {
          questions = state.exam.examQuestionsByExamId.nodes.map(
            (questionNode: any) => {
              let question = questionNode.questionByQuestionId;
              if (question.content && typeof question.content == 'string')
                question.content = question.content;
              if (
                question.interactiveData &&
                typeof question.interactiveData == 'string'
              ) {
                question.interactiveData = question.interactiveData;
              }
              if (
                questionNode.examVariantByExamVariantId &&
                questionNode.examVariantByExamVariantId.variantByVariantId
              ) {
                const examVariant =
                  questionNode.examVariantByExamVariantId.variantByVariantId;
                question.examVariant = examVariant;
                question.examVariant.id =
                  questionNode.examVariantByExamVariantId.id;
              } else {
                question.examVariant = null;
              }
              return question;
            },
          );
        }

        if (state.exam.assignment) {
          assignment = state.exam.assignment;
        }

        if (state.exam.fileBoxesByExamId) {
          fileBoxes = state.exam.fileBoxesByExamId.nodes;
        }

        if (state.exam.examGroupsExamsByExamId) {
          examGroups = state.exam.examGroupsExamsByExamId.nodes.map(
            (examGroup: any) => examGroup.examGroupByExamGroupId,
          );
        }

        isUeeWeeklyAssessment =
          state.exam.description &&
          state.exam.description
            .toUpperCase()
            .includes(weeklyAssessmentIdentifier);

        return {
          ...state.exam,
          questions,
          assignment,
          fileBoxes,
          examGroups,
          isUeeWeeklyAssessment,
        };
      }
      return {};
    },
    currentExamDuration: (state: any) => {
      if (state.exam) {
        return state.exam.duration;
      }
      return 0;
    },
    fileBoxes: (state: any) => (examId: number) => {
      return state.fileBoxes.filter(f => f.examId === examId);
    },
  },
  mutations: {
    SET_CURRENT_EXAM(state: any, exam: any) {
      state.exam = exam;
    },
    SET_EMPTY_EXAM(state: any) {
      let exam = {
        id: null,
        name: null,
        description: null,
        duration: null,
        start: null,
        end: null,
        questions: [],
        fileBoxes: [],
        examGroups: [],
        isUeeWeeklyAssessment: false,
      };
      state.exam = exam;
      state.questions = [];
      state.fileBoxes = [];
      state.examGroups = [];
    },
    SET_EXAM_QUESTIONS(state: any, questions: any) {
      state.questions = questions.map((question: any) => {
        if (question.content) question.content = question.content;
        if (question.interactiveData)
          question.interactiveData = question.interactiveData;
        return question;
      });
    },
    SET_EXAM_FILE_BOXES(state: any, fileBoxes: any) {
      state.fileBoxes = fileBoxes;
    },
    SET_EXAMS(state: any, exams: any[]) {
      state.exams = exams.map((exam: any) => {
        exam.examGroups = exam.examGroupsExamsByExamId.nodes.map(
          (examGroupsExams: any) => {
            return examGroupsExams.examGroupByExamGroupId;
          },
        );
        exam.questionsCount = exam.examQuestionsByExamId.totalCount;
        return exam;
      });
    },
    REMOVE_EXAM(state: any, index: number) {
      state.exams.splice(index, 1);
    },
  },
  actions: {
    async PULL_EXAM({ commit, state, rootState }: any, exam_id: number) {
      let user = rootState.auth.user;
      let getSolutions = '';
      if (user && user.id) {
        //TODO get solutions only when user finished exam
        getSolutions = `
              solutionsByQuestionId {
                nodes {
                  content
                }
              }
            `;
      }
      let response = await query(`query getExamByIdDexAdmin{
            examById(id: ${exam_id}) {
              id
              name
              slug
              description
              duration
              description
              start
              end
              ranked
              scoringStrategy
              scoringWeights
              privacyPolicyCheckRequired
              fileBoxesByExamId {
                nodes {
                  id
                  examId
                  name
                  mandatory
                }
              }
              examGroupsExamsByExamId {
                nodes {
                  examGroupByExamGroupId {
                    id
                    name
                    slug
                  }
                }
              }
              examQuestionsByExamId (
                orderBy: POSITION_ASC
              ) {
                nodes {
                  examVariantByExamVariantId {
                    id
                    variantByVariantId {
                      name
                      slug
                    }
                  }
                  position
                  questionByQuestionId {
                    id
                    content
                    alternatives
                    interactiveData
                    answer
                    ${getSolutions}
                    repliesByAlternative {
                      nodes {
                        answer
                        total
                      }
                    }

                    reportsByQuestionId (
                      condition: {
                        done: false
                      }
                    ) {
                      totalCount
                    }
                  }
                }
              }
            }
          }`);
      let exam = response.data.examById;
      commit('SET_CURRENT_EXAM', exam);
      commit('SET_EXAM_FILE_BOXES', exam.fileBoxesByExamId.nodes);
    },

    async PUSH_EXAM({ commit, state, rootState }: any, exam: any) {
      let userId = rootState.auth.user ? rootState.auth.user.id : null;
      let response;
      let examResponse;

      if (exam.duration) {
        exam.duration = parseInt(exam.duration);
      }

      if (exam.id != null) {
        const examQuestions = await query(
          `
            query PullExamQuestions($examId: Int!) {
              allExamQuestions(
                filter: {
                  examId: { equalTo: $examId }
                }
                orderBy: POSITION_ASC
              ) {
                nodes {
                  id
                }
              }
            }
          `,
          { examId: exam.id },
        );

        const examQuestionsToDelete = examQuestions.data.allExamQuestions.nodes;
        //update
        response = await mutation(
          `mutation updateExam (
            $examId: Int!, $name: String!, $description: String!,
            $duration: Int!, $start: Datetime!, $end: Datetime,
            $scoringStrategy: String, $scoringWeights: JSON,
            $ranked: Boolean!, $privacyPolicyCheckRequired: Boolean
          ) {
            updateExamById(
              input:
                {id: $examId,
                  examPatch:
                  {
                    name: $name,
                    description: $description,
                    duration: $duration,
                    start: $start,
                    end: $end,
                    scoringStrategy: $scoringStrategy,
                    scoringWeights: $scoringWeights,
                    ranked: $ranked,
                    privacyPolicyCheckRequired: $privacyPolicyCheckRequired
                  }
                }
            )
            {
              exam {
                id
                name
                duration
                description
                userId
                start
                end
                examQuestionsByExamId (
                  orderBy: POSITION_ASC
                ) {
                  nodes {
                    position
                    questionByQuestionId {
                      id
                      content
                      alternatives
                      interactiveData
                      answer
                    }
                  }
                }
              }
            }
          }`,
          {
            examId: exam.id,
            name: exam.name,
            description: exam.description,
            duration: exam.duration,
            start: exam.start,
            end: exam.end,
            scoringStrategy: exam.scoringStrategy,
            scoringWeights: exam.scoringWeights,
            ranked: !!exam.ranked,
            privacyPolicyCheckRequired: !!exam.privacyPolicyCheckRequired,
          },
        );

        examResponse = response.data.updateExamById.exam;

        if (examQuestionsToDelete.length > 0) {
          await mutation(
            `
              mutation deleteManyExamQuestions {
                ${examQuestionsToDelete.map(
                  (examQuestion: any, index: number) => `
                    examQuestion${index}: deleteExamQuestionById(input: {
                      id: ${examQuestion.id}
                    }) {
                      examQuestion {
                        id
                      }
                    }
                  `,
                )}
              }
            `,
          );
        }
      } else {
        //create
        response = await mutation(
          `mutation createExam (
            $userId: Int!, $name: String!, $description: String!,
            $duration: Int!, $start: Datetime!, $end: Datetime,
            $scoringStrategy: String!, $scoringWeights: JSON,
            $ranked: Boolean!, $privacyPolicyCheckRequired: Boolean
          ) {
            createExam(
              input:
                {exam:
                  {
                    userId: $userId,
                    name: $name,
                    description: $description,
                    duration: $duration,
                    start: $start,
                    end: $end,
                    scoringStrategy: $scoringStrategy,
                    scoringWeights: $scoringWeights,
                    ranked: $ranked,
                    privacyPolicyCheckRequired: $privacyPolicyCheckRequired
                  }
                }
            )
            {
              exam {
                id
                name
                duration
                description
                userId
                start
                end
                ranked
                privacyPolicyCheckRequired
                examQuestionsByExamId (
                  orderBy: POSITION_ASC
                ) {
                  nodes {
                    position
                    questionByQuestionId {
                      id
                      content
                      alternatives
                      interactiveData
                      answer
                    }
                  }
                }
              }
            }
          }`,
          {
            userId: userId,
            name: exam.name,
            description: exam.description,
            duration: exam.duration,
            start: exam.start,
            end: exam.end,
            scoringStrategy: exam.scoringStrategy,
            scoringWeights: exam.scoringWeights,
            ranked: !!exam.ranked,
            privacyPolicyCheckRequired: !!exam.privacyPolicyCheckRequired,
          },
        );
        examResponse = response.data.createExam.exam;

        if (examResponse.id && exam.filesEnabled) {
          await mutation(
            `mutation CreateFileBox ($name: String!, $mandatory: Boolean!, $examId: Int!) {
               createFileBox(input: { fileBox: { name: $name, mandatory: $mandatory, examId: $examId } }) {
                  fileBox {
                    id
                  }
               }
            }`,
          );
        }
      }

      let questions = exam.questions;
      if (examResponse.id && questions.length > 0) {
        await mutation(
          `mutation CreateMultipleExamQuestions($examId: Int!, $userId: Int!) {
          ${questions
            .map(
              (
                question: any,
                index: number,
              ) => `examQuestion${index}: createExamQuestion(
            input: {
              examQuestion: {
                examId: $examId,
                questionId: ${question.id},
                userId: $userId,
                position: ${index},
                examVariantId: ${
                  question.examVariant ? question.examVariant.id : null
                }
              }
            }
          ) {
            examQuestion {
              id
              examId
              position
              questionId
              examVariantId
            }
          }`,
            )
            .join('')}
        }`,
          {
            examId: examResponse.id,
            userId,
          },
        );
      }

      if (examResponse != null) {
        commit('SET_CURRENT_EXAM', examResponse);
      }
    },
    async PULL_QUESTIONS_BY_TAGS({ commit }: any, tag: string) {
      const response = await query(
        `query PullQuestion($tag: String) {
                allQuestions(filter: {
                  tags: {
                    includes: $tag
                  }
                }) {
                  nodes{
                    id
                    content
                    answer
                    source
                    mode
                    alternatives
                    interactiveData
                    group
                  }
                }
            }`,
        {
          tag,
        },
      );
      let questions = response.data.allQuestions;
      if (questions) {
        commit('SET_EXAM_QUESTIONS', questions.nodes);
      }
    },
    async ADD_QUESTIONS_BY_LIST_ID({ commit, state }: any, listId: any) {
      const response = await query(
        `query PullQuestion($listId: Int!) {
          allListItems(condition: {
            listId: $listId
          }) {
            nodes {
              questionByQuestionId {
                id
                content
                answer
                source
                mode
                alternatives
                interactiveData
                group
              }
            }
          }
        }`,
        {
          listId: +listId,
        },
      );

      let questions =
        (response.data.allListItems.nodes &&
          response.data.allListItems.nodes.map(n => n.questionByQuestionId)) ||
        [];
      questions = questions.filter(
        q => !state.questions.find(sq => sq.id == q.id),
      );

      commit('SET_EXAM_QUESTIONS', [...state.questions, ...questions]);
    },
    async ADD_FILE_BOX_BY_EXAM_ID({ commit }: any, examId: number) {
      const response = await mutation(
        `mutation addFileBox($examId: Int!) {
                createFileBox(input: {
                  fileBox: {
                    name: "respostas_assinadas",
                    mandatory: true,
                    examId: $examId
                  }
                }) {
                  examByExamId {
                    fileBoxesByExamId {
                      nodes {
                        id
                        examId
                        name
                        mandatory
                      }
                    }
                  }
                }
            }`,
        {
          examId,
        },
      );
      let fileBoxes = response.data.createFileBox
        ? response.data.createFileBox.examByExamId.fileBoxesByExamId
        : undefined;

      if (fileBoxes) {
        commit('SET_EXAM_FILE_BOXES', fileBoxes.nodes);
      }
    },
    async UPDATE_FILE_BOX({ commit }: any, fileBoxId: any) {
      const response = await mutation(
        `mutation pushFileBox($fileBoxId: Int!) {
            updateFileBoxById(
              input: {
                id: $fileBoxId, 
                fileBoxPatch: {
                  name: "respostas_assinadas"
                  mandatory: true
                }
              }) {
              examByExamId {
              fileBoxesByExamId {
                nodes {
                  id
                  examId
                  name
                  mandatory
                }
              }
            }
          }
        }`,
        {
          fileBoxId,
        },
      );
      let fileBoxes = response.data.updateFileBoxById
        ? response.data.updateFileBoxById.examByExamId.fileBoxesByExamId
        : undefined;

      if (fileBoxes) {
        commit('SET_EXAM_FILE_BOXES', fileBoxes.nodes);
      }
    },
    async PULL_EXAMS({ commit }: any, currentPage: number = 0) {
      let resultsPerPage = 50;
      let offset = resultsPerPage * currentPage;
      let response = await query(
        `query getAllExams2DexAdmin($resultsPerPage: Int, $offset: Int) {
        allExams(first: $resultsPerPage, offset: $offset, orderBy: ID_DESC){
          nodes{
            id
            name
            examGroupsExamsByExamId{
              totalCount
              nodes{
                examGroupByExamGroupId{
                  id
                  name
                }
              }
            }
            examQuestionsByExamId {
              totalCount
            }
          }
        }
      }`,
        {
          resultsPerPage,
          offset,
        },
      );
      let examNodes = response.data.allExams;
      if (examNodes) {
        commit('SET_EXAMS', examNodes.nodes);
      }
    },

    async REMOVE_EXAM({ commit }: any, examId: number) {
      try {
        let examQuestionsResponse = await query(
          `
          query getExamQuestionIds ($examId: Int!) {
            examById(id: $examId) {
              examGroupsExamsByExamId{
                totalCount
              }
              examQuestionsByExamId {
                nodes {
                  id
                }
              }
            }
          }
        `,
          {
            examId: +examId,
          },
        );

        if (
          examQuestionsResponse.data.examById.examGroupsExamsByExamId
            .totalCount > 0
        ) {
          throw 'Cannot delete exam with examGroup';
        }

        let examQuestions =
          examQuestionsResponse.data.examById.examQuestionsByExamId.nodes;

        if (examQuestions.length > 0) {
          //Deleting all exam questions
          let deleteExamQuestionsResponse = await mutation(
            `mutation deleteMultipleExamQuestions {
              ${examQuestions.map(
                (
                  examQuestion: any,
                  index: number,
                ) => `examQuestions${index}: deleteExamQuestionById(input: {
                  id: ${examQuestion.id}
                }) {
                  examQuestion {
                    id
                  }
                }`,
              )}
            }`,
          );
        }

        //Deleting the exam
        let response = await mutation(
          `mutation deleteExam($examId: Int!) {
            deleteExamById(input: {
              id: $examId
            }) {
              exam {
                id
              }
            }
          }`,
          {
            examId: +examId,
          },
        );

        return true;
      } catch (err) {
        return err;
      }
    },
  },
};
